import { randomString } from "../utils/general";
import { supabase } from "../supabase";
import { store } from "../stores/store";
import { UsersService } from "./users.service";
import { BrandService } from "./brand.service";
import { CommonService,CommonData } from "./common.service";

let _app;
export const AuthService = {
  setApp(appInstance) {
    _app = appInstance;
  },
  async initAuth() {
    const { data: { session } } = await supabase.auth.getSession();
  
    if (session?.user) {
      store.authUser = session.user;
  
      // if you also need profile/user_type
      const { user, error } = await UsersService.getUser(store.authUser.id);
      window.__insp.push(['tagSession', {email: user.email, userid: user.id}]);
      if (error) {
        await this.logout();
      }
      if (CommonData.categories.length == 0 || CommonData.countries.length == 0 || CommonData.languages.length == 0 || CommonData.nationalities.length == 0 || CommonData.professions.length == 0 || CommonData.tags.length == 0 || CommonData.states.length == 0 || CommonData.cities.length == 0) {
        await CommonService.getCommonData();
      }
      let noBrandAccess = false;
      if(user) {
        if (user.user_type == "staff") {
          store.setClientView(false);
        }
        if (user.user_type == "staff" && !user.brand) {
          const { data } = await supabase
          .from("brand")
          .select("*")
          .limit(1)
          .single();
          if (data) {
          const {brand} = await BrandService.getBrand(data.id);
          store.currentBrand = brand;
          }
          
        } else if (user.user_type == "client") {
          // Only brands the client still has (client_brands). A saved brand
          // whose access was revoked is not used; with no brand left the
          // client has no access at all (signed out with a message instead
          // of pages crashing on a missing brand).
          const { data: links, error: linksError } = await supabase
          .from("client_brands")
          .select("brand_id")
          .eq("client_id", user.id);
          const brandIds = (links || []).map((l) => l.brand_id);
          if (!linksError && !brandIds.length) {
            noBrandAccess = true;
          } else if (!linksError && (!user.brand || !brandIds.includes(user.brand.id))) {
            user.brand = null;
            const {brand} = await BrandService.getBrand(brandIds[0]);
            store.currentBrand = brand;
          }
          store.setClientView(true);
        }

        if (noBrandAccess) {
          await this.logout();
          store.accessMessage = "You no longer have access to any brand on Brand Ripplr. Please contact your Brand Ripplr team.";
        } else {
          store.currentUser = user;
          if (user.brand) {
            store.currentBrand = user.brand;
          }
        }
      }
    }
  
    // keep store in sync when auth state changes
    supabase.auth.onAuthStateChange((_event, session) => {
      store.authUser = session?.user || null;
    });
  },

 async loginWithEmail(email) {
  return await supabase.auth.signInWithOtp({
   email,
   options: {
    emailRedirectTo: window.location.origin + "/login-check",
    shouldCreateUser: false,
   },
  });
 },

 async verifyOTP(email, otp) {
  return await supabase.auth.verifyOtp({
   email,
   token: otp,
   type: "email",
  });
 },

 async signup(email) {
  try {
   if (!email) {
    throw new Error("Email is required");
   }
   return await supabase.auth.signUp({
    email,
    password: randomString(),
   });
  } catch (error) {
   // toast.error(error);
  }
 },

 async add(email) {
  try {
   if (!email) {
    throw new Error("Email is required");
   }
   const resp = await supabase.functions.invoke("create-user", {
    body: {
     email: email,
    },
   });
   if (resp.data.error) throw new Error(resp.data.error.message);
   if (resp.data.user) {
    return resp.data.user;
   }
  } catch (error) {
   const toast = _app.config.globalProperties.$toast;
   toast.add({ severity: "error", detail: error.message, life: 5000 });
  }
 },

 async logout() {
  const { error } = await supabase.auth.signOut();
  store.authSession = null;
  store.authUser = null;
  store.currentUser = null;
  // clear localstorage 
  localStorage.clear();

  if (error) {
   console.log(error);
  }
 },
};
